/**
 * @license
 * Copyright ACCEO Solution Inc. All Rights Reserved.
 */
/**
 * @module
 * @description
 * Entry point for all public APIs of the i18n package.
 */

export * from './l10n.module';
export * from './l10n.service';
